import React from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../lib/api';
import { EINRICHTEN_LINK } from '../../lib/zweiFaktor';
import { Button } from '../ui/button';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '../ui/dialog';

// Fehler bei /erinnert ignorieren: das Fenster lässt sich immer schließen.
const erinnert = () => api.post('/auth/me/2fa/erinnert').catch(() => {});

// Erinnerungsfenster: jedes Schließen zählt wie „Später erinnern“.
export const Erinnerung = ({ open, onClose, onAnleitung }) => {
  const navigate = useNavigate();
  const spaeter = () => { erinnert(); onClose(); };
  const jetzt = async () => { onClose(); await erinnert(); navigate(EINRICHTEN_LINK); };
  const anleitung = () => { spaeter(); onAnleitung(); };
  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) spaeter(); }}>
      <DialogContent className="max-h-[90vh] overflow-y-auto" data-testid="zwei-faktor-erinnerung">
        <DialogHeader>
          <DialogTitle className="font-[Manrope]">Bitte richten Sie die Zwei-Faktor-Anmeldung ein</DialogTitle>
          <DialogDescription>Das dauert 2 Minuten und schützt die Daten von Kindern und Mitarbeitenden.</DialogDescription>
        </DialogHeader>
        <button type="button" onClick={anleitung} className="w-fit text-left text-sm text-blue-700 hover:text-blue-900 hover:underline" data-testid="zwei-faktor-erinnerung-anleitung">
          Anleitung ansehen
        </button>
        <DialogFooter className="gap-2">
          <Button type="button" variant="outline" onClick={spaeter} data-testid="zwei-faktor-erinnerung-spaeter">Später erinnern</Button>
          <Button type="button" className="bg-blue-800 hover:bg-blue-900" onClick={jetzt} data-testid="zwei-faktor-erinnerung-jetzt">Jetzt einrichten</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default Erinnerung;
